export default __webpack_public_path__ + "static/media/1700.b0d78f22.png";